import { Role } from "@/acl/roles";
import { PRODUCTS_DETAILS } from "@/assets/constants/products/onyx-fo";
import { i18n } from "@/main.js";
import router from "@/router/index";

export default {
  orgName: "ONYX FO",
  redirectButtonNavBar: {
    getUrl: () => router.resolve({ name: "home" }).href,
    getText: () => i18n.t("wlps.onyxFo.redirectButtonNavBarText"),
    isInternal: true,
  },
  allowedLoginMethods: ["Google"],
  products: PRODUCTS_DETAILS,
  possibleRoles: [Role.superAdmin, Role.admin],
  admin: true,
  availableLanguages: ["en"],
};
